<script>
export default {
    props: ['app'],
    data: function () {
        return {

            w: 0,
            h: 0,
            bw: 3,
            zoom: 2,
            glass: {},
            img: {},
        }
    },
    methods: {
        nextGallery: function () {
            var number = this.app.galleryPhoto.number;

            $(".img-magnifier-glass").remove();

            if (this.app.photos.length === number) {
                this.app.galleryPhoto = this.app.photos[0]
            } else {
                number++;
                this.app.photos.map(photo => {
                    if (photo.number === number) {
                        this.app.galleryPhoto = photo;
                    }
                })
            }
        },
        prevGallery: function () {
            var number = this.app.galleryPhoto.number;

            $(".img-magnifier-glass").remove();

            if (number === 1) {
                this.app.galleryPhoto = this.app.photos[this.app.photos.length - 1]
            } else {
                number--;
                this.app.photos.map(photo => {
                    if (photo.number === number) {
                        this.app.galleryPhoto = photo;
                    }
                })
            }
        },
        magnify: function (imgID) {
            this.img = document.getElementById(imgID);
            this.zoom = 2;

            /* Create magnifier glass: */
            if (this.glass) $(".img-magnifier-glass").remove();
            this.glass = document.createElement("DIV");
            this.glass.setAttribute("class", "img-magnifier-glass");

            /* Insert magnifier glass: */
            this.img.parentElement.insertBefore(this.glass, this.img);

            /* Set background properties for the magnifier glass: */
            this.glass.style.backgroundImage = "url('" + this.img.src + "')";
            this.glass.style.backgroundRepeat = "no-repeat";
            this.glass.style.backgroundSize = (this.img.width * this.zoom) + "px " + (this.img.height * this.zoom) + "px";
            this.w = this.glass.offsetWidth / 2;
            this.h = this.glass.offsetHeight / 2;

            /* Execute a function when someone moves the magnifier glass over the image: */
            this.glass.addEventListener("mousemove", this.moveMagnifier, false);
            this.img.addEventListener("mousemove", this.moveMagnifier, false);

            /*and also for touch screens:*/
            this.glass.addEventListener("touchmove", this.moveMagnifier, false);
            this.img.addEventListener("touchmove", this.moveMagnifier, false);
        },
        moveMagnifier: function (e) {
            var pos, x, y;
            /* Prevent any other actions that may occur when moving over the image */
            e.preventDefault();
            /* Get the cursor's x and y positions: */
            pos = this.getCursorPos(e);

            x = pos.x;
            y = pos.y;

            /* Prevent the magnifier glass from being positioned outside the image: */
            if (x > this.img.width - (this.w / this.zoom)) {
                x = this.img.width - (this.w / this.zoom);
            }
            if (x < this.w / this.zoom) {
                x = this.w / this.zoom;
            }
            if (y > this.img.height - (this.h / this.zoom)) {
                y = this.img.height - (this.h / this.zoom);
            }
            if (y < this.h / this.zoom) {
                y = this.h / this.zoom;
            }
            /* Set the position of the magnifier glass: */
            this.glass.style.left = (x - this.w) + "px";
            this.glass.style.top = (y - this.h) + "px";
            /* Display what the magnifier glass "sees": */
            this.glass.style.backgroundPosition = "-" + ((x * this.zoom) - this.w + this.bw) + "px -" + ((y * this.zoom) - this.h + this.bw) + "px";
        },
        getCursorPos: function (e) {
            var a, x = 0, y = 0;
            e = e || window.event;
            /* Get the x and y positions of the image: */
            a = this.img.getBoundingClientRect();
            /* Calculate the cursor's x and y coordinates, relative to the image: */
            x = e.pageX - a.left;
            y = e.pageY - a.top;
            /* Consider any page scrolling: */
            x = x - window.pageXOffset;
            y = y - window.pageYOffset;
            return {x: x, y: y};
        },
        destroyZoom: function () {
            this.glass = {};
        },
    },
}
</script>

<template>
    <div class="gallery-holder slide-gallery" v-show="this.app.isMultipleGallery">
        <a href="javascript:void(0)" class="close" @click="this.app.isMultipleGallery = !this.app.isMultipleGallery"><i class="icon-close"></i></a>
        <div class="slide">
            <div class="image-holder b-shadow">
                <img class="not-retina" :src="this.app.multipleGalleryImg" alt="image description" @mouseenter="this.magnify('galleryProductSet')" id="galleryProductSet">
                <img class="retina" :src="this.app.multipleGalleryImg" alt="image description" @mouseenter="this.magnify('galleryProductSetR')" id="galleryProductSetR">
                <!-- fixme
                                    <img class="retina" src="/images/gallery-img@2x.jpg" alt="image description">
                -->
            </div>
            <div class="more-info b-shadow">
                <div class="title-block">
                    <h3>{{ trans("Vælg billede") }}</h3>
                </div>
                <div class="zoom">
                    <a href="javascript:void(0)" @click="this.app.isMultipleGallery = !this.app.isMultipleGallery"><i class="icon-zoom-out"></i></a>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
